import { defineStyle, defineStyleConfig } from "@chakra-ui/react";
import { SystemStyleObject } from "@chakra-ui/styled-system";

const baseStyle = defineStyle({
    lineHeight: "none",
    fontWeight: "medium",
    textTransform: "uppercase",
    letterSpacing: "wide",
    borderRadius: "base",
    transition: "all 0.3s",
    whiteSpace: "initial",
    _focusVisible: {
        outline: "1px dotted currentColor",
        transition: "all 0.1s",
    },
    _disabled: {
        opacity: 0.4,
        cursor: "not-allowed",
        boxShadow: "none",
    },
    _hover: {
        _disabled: {
            bg: "initial",
        },
    },
});

const sizes: Record<string, SystemStyleObject> = {
    sm: {
        fontSize: "2xs",
        py: "12",
        px: "16",
        svg: {
            width: 16,
            height: 16,
        },
        ".chakra-button__icon": {
            ml: "sp24",
        },
    },
    md: {
        fontSize: "xs",
        py: "16",
        px: "32",
        svg: {
            width: 24,
            height: 24,
        },
        ".chakra-button__icon": {
            ml: "sp32",
        },
    },
};

const variants = {
    primary: {
        color: "white",
        bg: "black",
        fill: "white",
        border: "1px solid",
        _hover: {
            bg: "white",
            color: "black",
            fill: "black",
        },
    },
    secondary: {
        color: "black",
        bg: "white",
        border: "1px solid",
        borderColor: "white",
        fill: "black",
        _hover: {
            bg: "black",
            color: "white",
            fill: "white",
            borderColor: "black",
        },
    },
    outline: {
        color: "black",
        bg: "transparent",
        border: "1px solid black",
        fill: "black",
        _hover: {
            bg: "black",
            color: "white",
            fill: "white",
        },
    },
    unstyled: {
        bg: "transparent",
        p: 0,
        textTransform: "none",
        ".chakra-button__icon": {
            ml: "sp8",
        },
    },
    sliderDot: {
        borderRadius: "100%",
        aspectRatio: "1",
        width: "8px",
        height: "8px",
        p: "0",
        _focusVisible: {
            outline: "1px red",
            transition: "all 0.1s",
        },
    },
};

export default defineStyleConfig({
    baseStyle,
    sizes,
    variants,
    defaultProps: {
        size: "md",
        variant: "primary",
    },
});
